import type { CentralBanksPageProps, PageProps } from "@/types";
import React, { FC, useRef } from "react";
import {
  CentraBanksExpandRegularEntities,
  CentraBanksOvercomeBlindSpots,
  CentralBanksHero,
  CentralBanksOpenDomesticPayments,
  CentralBanksScreenTransactions,
} from "../central-banks";
import { ContentManager } from "../content-manager";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";

export const CentralBanks: FC<PageProps<CentralBanksPageProps>> = (props) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });

  return (
    <div>
      <CentralBanksHero
        label="Central Banks"
        title={props.data.title}
        description={props.data.description}
        gallery={props.data.gallery}
      />
      <div ref={ref}>
        <SplitTextAnimation
          htmlElement={
            <ContentManager
              content={props.data.streamlineCriticalFunctionality}
              className="centralBanksStreamlineCriticalFunctionality--content"
            />
          }
          isInView={isInView}
        />
      </div>
      <CentraBanksOvercomeBlindSpots
        content={props.data.overcomeBlindSpotsContent}
        cover={props.data.overcomeBlindSpotsCover}
      />
      <CentralBanksScreenTransactions
        content={props.data.screenTransactionsContent}
        cover={props.data.screenTransactionsCover}
      />
      <CentralBanksOpenDomesticPayments
        content={props.data.openDomesticPaymentsContent}
        gallery={props.data.openDomesticPaymentsGallery}
      />
      <CentraBanksExpandRegularEntities
        content={props.data.expandRegulatedEntitiesContent}
        cover={props.data.expandRegulatedEntitiesCover}
      />
    </div>
  );
};
